import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';
import cancellationPolicy, { ICancellationPolicy } from './cancellationPolicy';
import localizedText, { ILocalizedText } from './localized-text';
import servicePriceSchema, { ServicePrice } from './service-price';

export interface IAvailabilityCodeCache {
  _id: ObjectID;
  availabilityCode: string;
  price: ServicePrice;
  title: ILocalizedText;
  subtitle?: ILocalizedText;
  roomType?: ILocalizedText;
  mealType?: ILocalizedText;
  cancellable: boolean;
  cancellationPolicies?: ICancellationPolicy[];
  updatedAt: Date;
  createdAt: Date;
}

export interface IAvailabilityCodeCacheDocument extends mongoose.Document, IAvailabilityCodeCache {
  _id: ObjectID;
}

const availabilityCodeCache = new Schema(
  {
    availabilityCode: {
      type: String,
      required: true,
      unique: true,
    },
    price: {
      type: servicePriceSchema,
      required: true,
    },
    title: {
      type: localizedText,
      required: true,
    },
    subtitle: { type: localizedText },
    roomType: { type: localizedText },
    mealType: { type: localizedText },
    cancellable: {
      type: Boolean,
      required: true,
    },
    cancellationPolicies: { type: [cancellationPolicy] },
  },
  { timestamps: true },
);

const thirtyDaysInSeconds = 2_592_000; // 30 days
availabilityCodeCache.index({ createdAt: 1 }, { expireAfterSeconds: thirtyDaysInSeconds });

export default availabilityCodeCache;
